var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-info-block"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"img",attrs:{"src":_vm.imgSrc,"alt":"头像"}}),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"intro"},[_vm._v(_vm._s(_vm.intro))]),_vm._v(" "),_c('p',{staticClass:"word",attrs:{"title":_vm.word}},[_vm._v(_vm._s(_vm.word)+"\n      "),_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90ce87ca","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/InfoBlock.vue
// module id = 257
// module chunks = 0